export default (that) => [
  {
    title: '#',
    field: 'seqno',
    width: 50,
    align: 'center',
    fixed: 'left',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
    sortType: 'string',
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'center',
    fixed: 'left',
    width: 120,
    slots: {
      default: 'opt',
    },
  },
  {
    title: that.$l('table_label_original_data_file_name') || '原始资料文件名',
    field: 'originalFileName',
    minWidth: 600,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
    sortType: 'string',
  },
  // {
  //   title: that.$l('table_label_raw_data_URL') || '原始资料Url',
  //   field: 'originalFileUrl',
  //   minWidth: 200,
  //   align: 'left',
  //   headerAlign: 'center',
  //   showHeaderOverflow: 'title',
  //   showOverflow: 'ellipsis',
  //   sortable: true,
  //   sortType: 'string',
  // },
  {
    title: that.$l('table_label_uploader_name') || '上传人名字',
    field: 'uploadByName',
    minWidth: 200,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
    sortType: 'string',
  },
  {
    title: that.$l('table_label_uploader_time') || '上传时间',
    field: 'uploadTime',
    minWidth: 170,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
    sortType: 'string',
  },
]
